import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';

function newsSlider() {
    const newsSliders = document.querySelectorAll('.news-slider');

    if (newsSliders.length > 0) {
        // Starting point
        newsSliders.forEach((newsSlider) => {

            function initializeSwiper() {

                let swiper = new Swiper(newsSlider, {
                    modules: [ Pagination, Navigation ],
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    slidesPerView: 1,
                    spaceBetween: 10,
                    loop: true,
                    // make slides clickable
                    slideToClickedSlide: true,
                });
            }

            // Initialize Swiper when the function is called
            initializeSwiper();

            // Also re-initialize when the window is resized
            window.addEventListener('resize', initializeSwiper);
        });
    }
}

export default newsSlider;